<template>
	<div class="page">
		<!-- your page -->
        <Head></Head>
        <div class="particulars">
			<div class="banner">
				<div class="bannerBack">
					<img src="../../assets/index/particularsBanner.png" alt="">
				</div>
				<div class="bannerInfo">
					<div class="fixation">
						<div class="logo">
							<div class="logoIn">
								<img :src="company.img" alt="">
							</div>
						</div>
						<div class="bannerName">
							<div class="nameBox">
								{{company.name}}
							</div>
							<div class="phone">
								<i class="el-icon-phone"></i>联系电话:{{company.tel}}
							</div>
						</div>
						<div class="qqService">
							<div class="qqServiceIn">
								<div class="qqServiceIcon">
									<img src="../../assets/index/qq.png" alt="">
								</div>
								<div class="qqServiceWord" @click="goservice">
									QQ客服
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
            <div class="fixation">
                <div class="top">
                    <div class="imgArea">
                        <imgList v-if="album.length!=0" v-bind:tid="tid" :album="album"></imgList>
                    </div>
                    <div class="info">
                        <div class="name">{{info.name}}</div>
                        <div class="brief">{{info.brief}}</div>
                        <div class="price">
                            <div class="infoTitle" v-if="from!='score'">售价</div>
							<div class="infoTitle" v-if="from=='score'">积分</div>
                            <div class="right">
                                <div class="priceBox" v-if="from!='score'">
                                    <div class="nowPrice">¥{{info.nowPrice}}</div>
                                    <div class="originPrice">¥{{info.originPrice}}</div>
                                </div>
								<div class="priceBox" v-if="from=='score'">
								    <div class="nowPrice">{{info.nowPrice}}</div>
								</div>
                            </div>
							<div class="sale">
							    销量:{{info.sale}}
							</div>
                        </div>
                        <div class="cost">
                            <div class="infoTitle">
                                运费
                            </div>
                            <div class="infoBox">
                                {{info.cost}}
                            </div>
                        </div>
                        <div class="specification" v-show="JSON.stringify(info.tab)!='{}'">
                            <div class="block">
                                <div class="tab" v-for="(item,index) in info.tab" :key="index">
                                    <div class="tabTitle">{{index}}</div>
                                    <div class="tabArea">
                                        <div class="tabItem" v-for="(tab,tabIndex) in item" @click="getInfo" :data-id="tab.product_id" :id="tab.is_default" :key="tabIndex">{{tab.name}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="number">
                            <div class="infoTitle">数量</div>
                            <div class="numberBox">
                                <div class="minus" @click="minus">-</div>
                                <div class="nums">{{info.nums}}</div>
                                <div class="sum" @click="add">+</div>
                            </div>
                        </div>
                        <div class="btns">
                            <div class="into" @click="addBuyCar" v-if="from!='score'">
                                <div class="icon">
                                    <img src="../../assets/index/buycar.png" alt="">
                                </div>
                                <div class="word">
                                    加入购物车
                                </div>
                            </div>
                            <div class="buy" @click="buyNow" v-if="from!='score'">
                                立即购买
                            </div>
							<div class="buy" @click="buyNow" v-if="from=='score'">
							    立即兑换
							</div>
                            <div class="service" @click="goservice">
                                <div class="icon"><img src="../../assets/index/service.png" alt=""></div>
                                <div class="word">客服</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="down">
					<div class="recommend">
						<div class="title">
							看了又看
						</div>
	                    <more></more>
	                </div>
	                <div class="explain">
	                    <div class="explainNav">
	                        <div class="explainItem" :data-id="1" :id="select1" @click="tabChange">
	                            商品介绍
	                        </div>
	                        <div class="explainItem" :data-id="2" :id="select2" @click="tabChange">
	                            商品评价
	                        </div>
	                    </div>
                        <div class="detail" v-show="vShow">
							<div class="detailBox" v-html="intro">
								{{intro}}
							</div>
                        </div>
                        <div class="evaluate" v-show="!vShow">
							<evaluateList v-if="JSON.stringify(info)!='{}'" v-bind:eid="info.id"></evaluateList>
                        </div>
	                </div>
                </div>
            </div>
        </div>
		<Foot></Foot>
	</div>
</template>

<script>
	// your script
    import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
    import imgList from '../../components/imgList.vue'
    import evaluateList from '../../components/evaluateList.vue'
    import info from '../../components/info.vue'
    import more from '../../components/more.vue'
	export default {
		name: 'particulars',
        components:{
			Head,Foot,imgList,info,evaluateList,more
		},
		data(){
			return {
				tid:"",
				bread:"",
				vShow:true,
				shareShow:false,
				select1:"select",
				select2:"",
				company:{
					// "logo":require("../../assets/index/particularsLogo.png"),
					// "name":"AMD战未来",
					// "phone":"0311-82002200"
				},
                info:{
					// "name":"AMD YES~!高端性价比CPU 2700X，秒杀INTEL 8700K，华硕X-470 prime主板套装3199，ROG X-470F GAMING主板套装 3699，Radeon VII信仰三A，战未来！",
					// "brief":"华硕品质，全固大板，AMD顶级CPU，显卡，全力加持，另有INTEL次级旗舰，2080TI超级核弹，打造顶级信仰红",
					// "nowPrice":"3199.00",
					// "originPrice":"3798.00",
					// "sale":"1400",
					// "cost":"30.00",
					// "tab":{
					// 	"类型":[{"name":"TUF B450M 爆款性价比","product_id":"22","is_default":true},{"name":"TUF B450 PLUS 电竞大板","product_id":"23"},{"name":"TUF B450M 爆款性价比+2600X性价套装","product_id":"24"},{"name":"TUF B450 PLUS+2600X 大板加持","product_id":"25"},{"name":"prime X470 PRO专业大板","product_id":"26"},{"name":"ROG X470F-GAMING电竞极致","product_id":"27"},{"name":"prime X470 pro+2700X专业套装","product_id":"28"},{"name":"ROG X470F-GAMING+2700X极致套装","product_id":"28"},{"name":"AMD 2600X","product_id":"29"},{"name":"AMD 2700X","product_id":"30"},{"name":"INTEL 8700K","product_id":"31"},{"name":"AMD Radeon VII HBM2","product_id":"32"},{"name":"NVIDIA RTX 2080TI","product_id":"33"}],
					// 	"套餐":[{"name":"套餐1","product_id":"22","is_default":true},{"name":"套餐2","product_id":"23"},{"name":"套餐3","product_id":"24"},{"name":"套餐4","product_id":"25"}]
					// },
					// "nums":1,
					// "id":"12345"
				},
				share:[
					{
						"src":require('../../assets/index/qq.png'),
						"name":"QQ"
					},
					{
						"src":require('../../assets/index/wechat.png'),
						"name":"微信"
					}
				],
				album:[
					// require('../../assets/index/imgList1.jpg'),
					// require('../../assets/index/imgList2.jpg'),
					// require('../../assets/index/imgList3.jpg'),
					// require('../../assets/index/imgList4.jpg'),
					// require('../../assets/index/imgList5.jpg'),
					// require('../../assets/index/imgList6.jpg'),
				],
				intro:"<div>AMD</div>",
				pcUrl:"",
				mobileUrl:"",
				qrcode:"",
				from:""
			}
		},
		methods:{
			fetchCompany(){
				var data = {
					method:"user.seller"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.company = res.data
					}else{
						that.globalTest('user.seller','error',res.msg,res.data)
					}
				})
			},
			onCopy(){
				this.globalTest('success','复制成功！快分享给好友吧')
			},
			onCopyFail(){
				this.globalTest('error','复制失败，请稍候重试或者联系客服')
			},
			closeBtn(){
				this.shareShow = false
			},
			goShare(){
				var id = this.id
				var data = {
					"method":"forum.goods_qr",
					"gid":id,
					"token":this.token
				}
				var that = this
				this.request(data,function(res){
					that.shareShow=true
					if(res.status){
						that.qrcode = res.data
					}else{
						var msg = res.msg
						that.globalTest('error',msg,res.data)
					}
				})
				this.getMobileUrl()
			},
			getMobileUrl(){
				var data = {
					"method":"forum.goods",
					"token":this.token,
					"id":this.id
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.mobileUrl = res.data
					}else{
						var msg = res.msg
						that.globalTest('error',msg,res.data)
					}
				})
			},
			goservice(){
				var that = this
				window.open('http://wpa.qq.com/msgrd?v=3&uin='+that.company.qq+'&site=qq&menu=yes')
			},
			minus(){
				var info = this.info
				if(info.nums>1){
					info.nums = info.nums-1
				}
				this.info = info
			},
			reload(){
				this.$router.go(0)
			},
			add(){
				var info = this.info
				info.nums = info.nums+1
			},
			getInfo(e){
				var id = e.target.dataset.id
				var data = {
					id:id,
					method:"goods.getproductinfo"
				}
				var info = this.info
				var that = this
				this.request(data,function(res){
					if(res.status){
						var spes = res.data.default_spes_desc
						var tab = {}
						if(spes){
							var keys = Object.keys(spes)
							for (let i in keys) {
								var key = keys[i]
								tab[key]=new Array()
								for (let k in spes[key]) {
									tab[key].push(spes[key][k])
								}
							}
						}
						info["name"]=res.data.name
						info["nowPrice"]=res.data.price
						info["originPrice"]=res.data.mktprice
						info["sale"]=res.data.buy_count
						info["cost"]=res.data.costprice
						info["tab"]=tab
						info["nums"]=1
						info["id"]=res.data.id
						if(that.from=='score'){
							info['nowPrice'] = res.data.integral_price
						}
						that.info = info
					}else{
						var msg = res.msg
						that.globalTest('error',msg,res.data)
					}
				})
			},
			addBuyCar(){
				var token = this.token
				var data = {
					product_id:this.info.id,
					token:token,
					nums: this.info.nums,
					method: "cart.add"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.globalTest('cart.add','success','加入购物车成功')
					}else{
						var msg = res.msg
						that.globalTest('cart.add','error',msg,res.data)
					}
				})
			},
			buyNow(){
				var data = {
					product_id: this.info.id,
					nums: this.info.nums,
					type: 2,    //1是累加，2是覆盖
					token: this.token,
					method: 'cart.add'
				}
				if(this.from=='score'){
					data['is_integral'] = 1
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var cartIds = res.data
						that.$router.push({path:"/newOrder",query:{cartIds:cartIds,from:that.from}})
					}else{
						var msg = res.msg
						that.globalTest('cart.add','error',msg,res.data)
					}
				})
			},
			tabChange(e){
				var id = e.target.dataset.id
				if(id==1){
					this.vShow = true
					this.select1="select"
					this.select2=""
				}else{
					this.vShow = false
					this.select1=""
					this.select2="select"
				}
			},
			fetchData(){
				var id = this.id
				var data = {
					"id":id,
					"method":"goods.getdetial"
				}
				var that = this
				var info = {}
				this.request(data,function(res){
					if(res.status){
						var spes = res.data.product.default_spes_desc
						var tab = {}
						if(spes){
							var keys = Object.keys(spes)
							for (let i in keys) {
								var key = keys[i]
								tab[key]=new Array()
								for (let k in spes[key]) {
									tab[key].push(spes[key][k])
								}
							}
						}
						var id
						if(res.data.default){
							id = res.data.default.id
						}else{
							id = res.data.id
						}
						info={
						    "name":res.data.name,
						    "brief":res.data.brief,
						    "nowPrice":res.data.price,
						    "originPrice":res.data.mktprice,
						    "sale":res.data.buy_count,
						    "cost":res.data.costprice,
						    "tab":tab,
						    "nums":1,
						    "id":id
						}
						if(that.from=='score'){
							info['nowPrice'] = res.data.integral_price
						}
						that.info = info
						var intro = res.data.intro
						that.intro = intro
						var album = res.data.album
						that.album = album
					}else{
						var msg = res.msg
						that.globalTest('error',msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			
		},
		beforeMount: function() {
			//模板编译/挂载之前
			
		},
		mounted: function() {
			//模板编译/挂载之后
			this.id = this.$route.query.cid
			this.from = this.$route.query.from
			var token = localStorage.getItem('token')
			this.token = token
			this.fetchData()
			this.pcUrl = window.location.href
			this.fetchCompany()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
    .particulars{
        width: 100%;
        background: #F0F0F0;
    }
	.banner{
		width: 100%;
		position: relative;
	}
	.bannerBack{
		width: 100%;
	}
	.bannerBack img{
		width: 100%;
		display: block;
	}
	.banner .bannerInfo{
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		position: absolute;
	}
	.bannerInfo .fixation{
		background: none;
	}
	.logo{
		width: 200px;
		height: 100%;
		float: left;
	}
	.logoIn{
		width: 100%;
		height: 70px;
		margin-top: 25px;
	}
	.logoIn img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.bannerName{
		width: 300px;
		height: 100%;
		float: left;
		padding-top: 30px;
		box-sizing: border-box;
		margin-left: 20px;
	}
	.bannerName .nameBox{
		width: 100%;
		height: 40px;
		font-size: 20px;
		font-weight: 600;
		line-height: 40px;
	}
	.bannerName .phone{
		width: 100%;
		height: 30px;
		color: #838383;
		letter-spacing: 1px;
	}
	.bannerName .phone i{
		color: #036DEE;
	}
	.qqService{
		width: 300px;
		height: 100%;
		float: right;
	}
	.qqServiceIn{
		width: 100px;
		height: 40px;
		float: right;
		margin-top: 40px;
		background: #FFFFFF;
		line-height: 40px;
		color: #036DEE;
		cursor: pointer;
	}
	.qqServiceIcon{
		width: 30px;
		height: 100%;
		float: left;
	}
	.qqServiceIcon img{
		width: 20px;
		display: block;
		margin: 10px auto;
	}
    .fixation{
        background: #FFFFFF;
    }
    .top{
        width: 100%;
        font-size: 0px;
        letter-spacing: -6px;
        padding-top: 20px;
        box-sizing: border-box;
    }
    .imgArea,.info{
        display: inline-block;
        vertical-align: top;
        letter-spacing: normal;
        font-size: 14px;
    }
    .imgArea{
        width: 400px;
        height: 500px;
		position: relative;
    }
    .info{
        width: 780px;
        margin-left: 20px;
    }
    .name{
        width: 80%;
        padding: 10px 0px;
        box-sizing: border-box;
        line-height: 26px;
        font-size: 18px;
        font-weight: 600;
    }
    .brief{
        width: 80%;
        box-sizing: border-box;
        line-height: 24px;
        font-size: 14px;
        color: #838383;
		overflow: hidden;
		height: 48px;
    }
    .price{
        width: 80%;
        background: #E0E0E0;
        position: relative;
    }
    .infoTitle,.tabTitle{
        width: 100px;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        line-height: 50px;
		padding-left:10px;
		box-sizing: border-box;
    }
    .price .right{
        width: 100%;
        height: 100%;
        padding-left: 100px;
		padding-right: 150px;
        box-sizing: border-box;
    }
    .priceBox{
        width: 100%;
        height: 50px;
        font-size: 0px;
        letter-spacing: -6px;
        line-height: 50px;
    }
	.sale{
	    width: 150px;
	    height: 50px;
	    line-height: 50px;
	    color: #838383;
		position:absolute;
		right: 0px;
		top:0px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-right: 10px;
		box-sizing: border-box;
	}
    .nowPrice,.originPrice{
        box-sizing: border-box;
        height: 100%;
        display: inline-block;
        vertical-align: top;
        letter-spacing: normal;
    }
    .nowPrice{
        color: red;
        font-size: 18px;
        font-weight: 600;
    }
    .originPrice{
        color: #838383;
        text-decoration: line-through;
        margin-left: 20px;
    }
    .cose,.specification,.number,.btns{
        margin-top: 10px;
    }
    .cost{
        width: 100%;
        height: 50px;
        line-height: 50px;
        position: relative;
    }
    .infoBox{
        width: 100%;
        height: 100%;
        padding-left: 100px;
        box-sizing: border-box;
    }
    .specification{
        width: 100%;
    }
    .block{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-top: 5px;
    }
    .block .tab{
        width: 100%;
		position: relative;
    }
    .block .tab .tabArea{
        width: 100%;
		padding-left: 90px;
		box-sizing: border-box;
        font-size: 0px;
        letter-spacing: -6px;
    }
    .block .tab .tabArea .tabItem{
        display: inline-block;
        padding:0px 10px;
        height: 24px;
        background: #F0F0F0;
        border:1px solid #D3D3D3;
        line-height: 22px;
        vertical-align: top;
        font-size: 12px;
        letter-spacing: normal;
		margin-left: 10px;
		margin-top: 10px;
		color: #333333;
    }
	.block .tab .tabArea #true{
		background: #cce2ff;
	}
    .number{
        width: 100%;
        height: 50px;
        position: relative;
    }
    .numberBox{
        width: 100%;
        height: 100%;
        padding-left: 100px;
        box-sizing: border-box;
        line-height: 30px;
        padding-top: 10px;
    }
    .sum,.minus{
        width: 30px;
        height: 30px;
        float: left;
        border: 1px solid #B3B3B3;
        box-sizing: border-box;
        text-align: center;
    }
    .nums{
        height: 30px;
        float: left;
        border-top: 1px solid #B3B3B3;
        border-bottom: 1px solid #B3B3B3;
        padding: 0px 10px;
        box-sizing: border-box;
        float: left;
    }
    .btns{
        width: 100%;
        height: 50px;
    }
    .into,.buy,.share,.service{
        width: 120px;
        height: 40px;
        float: left;
        line-height: 40px;
        margin-left: 20px;
		cursor: pointer;
    }
    .into{
        border: 1px solid #036DEE;
        box-sizing: border-box;
        margin-left: 0px;
        color: #036DEE;
    }
    .into .icon,.share .icon,.service .icon{
        width: 40px;
        height: 100%;
        float: left;
    }
    .into .icon img,.share .icon img,.service .icon img{
        width: 16px;
        height: 16px;
        display: block;
        margin: 11px auto;
    }
    .into .word,.share .word,.service .word{
        width: 78px;
        height: 100%;
        float: left;
		line-height: 38px;
    }
	.share{
		position: relative;
	}
	.shareBox{
		width: 500px;
		position:absolute;
		left: 0px;
		top: 40px;
		height: 170px;
		box-sizing: border-box;
	}
	.shareBox .shareArea{
		width: 100%;
		height: 160px;
		background: #FFFFFF;
		border:1px solid #B3B3B3;
		margin: 0 auto;
		margin-top: 5px;
		position: relative;
		box-sizing: border-box;
	}
	.shareArea .arrow{
		width: 16px;
		height: 16px;
		position: absolute;
		top: -9px;
		left: 10px;
		transform:rotate(45deg);
		background: #FFFFFF;
		border-top: 1px solid #B3B3B3;
		border-left: 1px solid #b3b3b3;
		box-sizing: border-box;
	}
	.shareArea .close{
		width: 100%;
		height: 20px;
		position: absolute;
		right: 0px;
		top:0px;
	}
	.shareArea .close img{
		width: 14px;
		height: 14px;
		display: block;
		float:right;
		margin-top: 3px;
		margin-right: 3px;
	}
	.shareArea .qrcode{
		width:120px;
		height: 100%;
		padding-top: 5px;
		box-sizing: border-box;
		float: left;
	}
	.shareArea .qrcode img{
		width: 110px;
		height: 110px;
		display: block;
		margin: 5px auto;
	}
	.shareArea .shareBtns{
		width: 370px;
		height: 100%;
		float: left;
		padding-top: 20px;
		box-sizing: border-box;
	}
	.shareLine{
		width: 100%;
		height: 40px;
		position: relative;
		line-height: 40px;
		margin-top: 10px;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
	}
	.shareLine .shareTitle{
		width: 90px;
		height: 100%;
		float: left;
	}
	.shareLine .inputBox{
		width: 200px;
		height: 100%;
		float: left;
	}
	.shareLine .inputBox input{
		width: 96%;
		height: 80%;
		border: none;
		display: block;
		border: 1px solid #D3D3D3;
		box-sizing: border-box;
		margin-top: 2%;
	}
	.shareLine .copyButton{
		width: 78px;
		height: 100%;
		float: left;
		background: #004444;
	}
	.shareLine .copyButton button{
		width: 100%;
		height: 100%;
		background: #333333;
		color: #FFFFFF;
		display: block;
		border: none;
	}
	.shareOut{
		height: 26px;
		float: left;
		line-height: 14px;
		font-size: 12px;
		padding: 0px 3px;
		text-align: center;
		box-sizing: border-box;
	}
    .buy{
        background: #036DEE;
        color: white;
        text-align: center;
    }
    .down{
        width: 100%;
        margin-top: 20px;
        letter-spacing: -6px;
        font-size: 0px;
    }
    .recommend,.explain{
        display: inline-block;
        vertical-align: top;
        letter-spacing: normal;
        font-size: 14px;
    }
    .recommend{
        width: 280px;
    }
    .recommend .title{
        width: 100%;
        height: 40px;
        text-align: left;
        line-height: 40px;
        padding-left: 15px;
		font-size: 16px;
		font-weight: bold;
    }
    .explain{
        width: 900px;
        height: 100%;
        margin-left: 20px;
    }
    .explainNav{
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #036DEE;
        box-sizing: border-box;
		color: #036DEE;
    }
    .explainNav .explainItem,.mobile{
        width: 150px;
        height: 100%;
        border:1px solid #036DEE;
		border-bottom: none;
        float: left;
        text-align: center;
        line-height: 40px;
        box-sizing: border-box;
    }
	.mobile{
		float: right;
		border:none;
	}
	.mobile img{
		width: 16px;
		height: 16px;
		float: right;
		margin-top: 12px;
		margin-right: 10px;
	}
	.explainNav #select{
		background: #036DEE;
		color: #FFFFFF;
	}
	.detail{
		width: 100%;
	}
	.evaluate{
		width: 100%;
	}
</style>
